import {useEffect, useState} from 'react';
import {useUserConsent} from '@tempo/cookie';

interface ConsentState {
	hasConsent: boolean;
	hasAnalytics: boolean;
	hasMarketing: boolean;
	isLoading: boolean;
}

export const useGTMConsent = (): ConsentState => {
	const [gtmConsentState, setGtmConsentState] = useState<ConsentState>({
		hasConsent: false,
		hasAnalytics: false,
		hasMarketing: false,
		isLoading: true,
	});

	const {consentSettings} = useUserConsent();

	useEffect(() => {
		if (consentSettings === undefined) {
			setGtmConsentState((prevState) => ({
				...prevState,
				hasConsent: false,
				hasAnalytics: false,
				hasMarketing: false,
				isLoading: true,
			}));
			return;
		}

		const analyticsAllowed = consentSettings.statistics === 1;
		const marketingAllowed = consentSettings.targetedAdvertising === 1;
		const generalConsentGiven = analyticsAllowed || marketingAllowed;

		setGtmConsentState({
			hasConsent: generalConsentGiven,
			hasAnalytics: analyticsAllowed,
			hasMarketing: marketingAllowed,
			isLoading: false,
		});

		if (process.env.NODE_ENV === 'development') {
			// eslint-disable-next-line no-console
			console.log('GTMConsent Hook: Consent settings from useUserConsent', {
				consentSettings: consentSettings.consentString,
				statistics: consentSettings.statistics,
				targetedAdvertising: consentSettings.targetedAdvertising,
				derivedAnalytics: analyticsAllowed,
				derivedMarketing: marketingAllowed,
				derivedGeneral: generalConsentGiven,
			});
		}
	}, [consentSettings]);

	return gtmConsentState;
};
